import moment from "moment";
import {isBeforeDate} from "./dateHelper";
import type {pendingTransactionsModel} from "../models/authorizationModel";

/*
array = an array of object or just an array
filed = if it is an object array, what variable will be displayed
type = in case of manipulate the data (like date)
 */
// const transactionsDdMock = [
//     { value: '0', label: 'England' },
//     { value: '1',  label: 'Spain'},
//     { value: '2',  label: 'Thailand' },
//     { value: '3',  label: 'USA'}
// ];

export const prepperDataToDropDown = ( array , field , type = null) => {
      const newArray= [];
      newArray.push({ value: 0, label: 'Activity since last statement', disabled: true },);
      array.map( (item, index )=> {
        let itemToArray;
        if(type === "Date") {
          const original = field ? item[field] : item; // in case there is mullty variables so the user will need to define a field name
          const isBefore = isBeforeDate( "2020-01-20"  , original ); // if its before its means that this date need to be hidden true ==> transactionDate is after
          if(isBefore) {
                      itemToArray = {value : index + 1 ,
                                     original : original,
                                     disabled: false,
                                     label : field ?  moment(item[field]).format("MMM DD, YYYY") :  moment(item).format("MMM DD, YYYY")};
          }
        } else {
          itemToArray = {value : index , label : field ? item[field] : item};
        }
          itemToArray ? newArray.push(itemToArray) : '';
      });
      return newArray;
};


export const tableDataTransactions = ( array : [{postDate : string ,aggregateTransactionAmount : string , transactionAmount: number , transactionDate : string}]) => {
  const newArray= [];
  array.map( (item )=> {
    let itemToArray;
      itemToArray ={...item,
                    transactionDate : item.postDate ? item.postDate : item.transactionDate,
                    aggregateTransactionAmount : item.aggregateTransactionAmount ? item.aggregateTransactionAmount : item.transactionAmount  };
      newArray.push(itemToArray);
  });
  return newArray;
};

export const tablePendingTransactions = ( array ) => {
  const newArray= [];
  array.map( (item : pendingTransactionsModel)=> {
    let itemToArray;
    itemToArray ={...item,
      aggregateTransactionAmount : item.authorizationAmount ? item.authorizationAmount : '' ,
      transactionDate : item.authorizationDate ? item.authorizationDate : ''  ,
      merchantDescription : item.merchantName ? item.merchantName : ''  };
    newArray.push(itemToArray);
  });
  return newArray;
};



// WEBPACK FOOTER //
// ./src/utils/dataHelper.js